export default "__VITE_ASSET__D$3quYzt__"